/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PublishHouseDto from './PublishHouseDto';
import SupplierMainDto from './SupplierMainDto';

/**
 * The SupplierDto model module.
 * @module model/SupplierDto
 * @version v1.0.0
 */
class SupplierDto {
    /**
     * Constructs a new <code>SupplierDto</code>.
     * @alias module:model/SupplierDto
     */
    constructor() { 
        
        SupplierDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SupplierDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SupplierDto} obj Optional instance to populate.
     * @return {module:model/SupplierDto} The populated <code>SupplierDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SupplierDto();

            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('main')) {
                obj['main'] = ApiClient.convertToType(data['main'], [SupplierMainDto]);
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('publishHouses')) {
                obj['publishHouses'] = ApiClient.convertToType(data['publishHouses'], [PublishHouseDto]);
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} description
 */
SupplierDto.prototype['description'] = undefined;

/**
 * @member {String} id
 */
SupplierDto.prototype['id'] = undefined;

/**
 * @member {Array.<module:model/SupplierMainDto>} main
 */
SupplierDto.prototype['main'] = undefined;

/**
 * @member {String} name
 */
SupplierDto.prototype['name'] = undefined;

/**
 * @member {Array.<module:model/PublishHouseDto>} publishHouses
 */
SupplierDto.prototype['publishHouses'] = undefined;

/**
 * @member {Number} seq
 */
SupplierDto.prototype['seq'] = undefined;






export default SupplierDto;

